import { Grid, Typography, Card} from '@mui/material'
import { useSelector } from 'react-redux';
import { selectUserInfo } from '../../../features/userInfo/userInfoSlice';
import { ReactComponent as MyProfileIcon} from '../../../icons/teDhenatIcon.svg';
import colors from '../../colors';
import React from 'react'
import { makeStyles } from '@mui/styles';
import { texts } from '../../general/texts';


export const ProfileDetails = () => {

    const userInfo = useSelector(selectUserInfo)

    const useStyles = makeStyles({
        card:{
            width:'50%',
            borderRadius:'20px',
            boxShadow:'0 0 15px 5px #E5E7EA',
            '@media (max-width: 899px)' : {width:'90%'}
        },
        iconBox:{
            backgroundColor: colors.cyan,
            borderRadius:'20px',
            width:'60px',
            height:'60px',
            marginLeft:'3%'
        },
        cardTitle:{
            color: colors.darkBlue,
            fontSize:'1.5rem',
            fontFamily:'GerberaBold',
            paddingTop:'1%',
            paddingLeft:'2%'
        },
        fieldTitle:{
            color:colors.orange,
            fontSize:'1rem',
            paddingBottom:'0.5%',
            fontFamily:'GerberaMedium'
        },
        fieldInfo:{
            color:colors.gray,
            fontSize:'0.9rem',
            fontFamily:'GerberaLight'
        }
    })

    const classes = useStyles()
    // React.useEffect(() => {
    //     dispatch(sendGeneralRequest({request: {token: globalDataSliceState.token}, baseUrlKey: 'services', endpoint:'GetAccountInfoNew'}))
    //   }, [])

  return (
    <Grid container item justifyContent={'center'} pt={'3%'} >
    <Card className={classes.card} >
        <Grid container rowSpacing={7} pt={'3%'} pb={'8%'} >
            <Grid container item md={12} xs={12} >
                <Grid container  direction="column" justifyContent="center" alignItems="center" className={classes.iconBox}>
                    <MyProfileIcon />
                </Grid>
                <Typography className={classes.cardTitle} >{texts["placeholder-personal-data"]}</Typography>
                
                {/* <Grid container item md={2} xs={5} alignItems={'right'} ><Button sx={{mt:'3%', height:'2rem', fontSize:'0.6rem', color:colors.darkBlue, border:'1px solid', borderColor:colors.darkBlue, borderRadius:'10px'}} >Ndrysho të dhënat</Button></Grid> */}
            </Grid>
            <Grid container item  rowSpacing={5} pl={'3%'}>
                <Grid item md={6} xs={6} textAlign={'left'} >
                    <Typography className={classes.fieldTitle} >{texts["title-full-name"]}</Typography>
                    <Typography className={classes.fieldInfo}>{userInfo.name}</Typography>
                </Grid>
                <Grid item md={6} xs={6} textAlign={'left'} >
                    <Typography className={classes.fieldTitle}>{texts["placeholder-phone-number"]}</Typography>
                    <Typography className={classes.fieldInfo}>{userInfo.phone}</Typography>
                </Grid>
                <Grid item md={6} xs={6} textAlign={'left'} >
                    <Typography className={classes.fieldTitle}>{texts["dialog-city"]}</Typography>
                    <Typography className={classes.fieldInfo}>{userInfo.city}</Typography>
                </Grid>
                <Grid item md={6} xs={6} textAlign={'left'} >
                    <Typography className={classes.fieldTitle}>{texts["placeholder-address"]}</Typography>
                    <Typography className={classes.fieldInfo}>{userInfo.address}</Typography>
                </Grid>
                
            </Grid>
        </Grid>
    </Card>
    </Grid>
  )
}
export default ProfileDetails